/**
 * PDF Popup Handler for Collection List
 */

class PDFPopup {
  constructor() {
    this.triggers = document.querySelectorAll('.pdf-popup-trigger');
    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => this.handleClick(e));
    });
  }

  handleClick(event) {
    const trigger = event.currentTarget;
    const pdfUrl = trigger.dataset.pdfUrl;
    const title = trigger.dataset.collectionTitle;

    // Create modal HTML
    const modal = document.createElement('div');
    modal.className = 'pdf-modal';
    modal.innerHTML = `
      <div class="pdf-modal__overlay"></div>
      <div class="pdf-modal__content">
        <div class="pdf-modal__header">
          <h2>${title}</h2>
          <button type="button" class="pdf-modal__close">&times;</button>
        </div>
        <div class="pdf-modal__body">
          <iframe src="${pdfUrl}" frameborder="0"></iframe>
        </div>
      </div>
    `;

    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      .pdf-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .pdf-modal__overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
      }
      .pdf-modal__content {
        position: relative;
        width: 90%;
        max-width: 1200px;
        height: 90vh;
        background: white;
        z-index: 1;
        display: flex;
        flex-direction: column;
      }
      .pdf-modal__header {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;
      }
      .pdf-modal__close {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        padding: 0 8px;
      }
      .pdf-modal__body {
        flex-grow: 1;
        overflow: hidden;
      }
      .pdf-modal__body iframe {
        width: 100%;
        height: 100%;
        border: 0;
      }
    `;

    // Add to DOM
    document.head.appendChild(style);
    document.body.appendChild(modal);

    // Handle close
    const close = () => {
      document.body.removeChild(modal);
    };

    modal.querySelector('.pdf-modal__close').addEventListener('click', close);
    modal.querySelector('.pdf-modal__overlay').addEventListener('click', close);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new PDFPopup();
});